import { Subheading } from "../../../design/heading";
import { Document } from "../../../models/Document";

interface ChooseDocumentTypeProps {
  type: Document["type"] | undefined;
  setType: React.Dispatch<React.SetStateAction<Document["type"] | undefined>>;
}

const options: {
  value: Document["type"];
  label: string;
  description: string;
}[] = [
  {
    value: "general",
    label: "General",
    description: "Add general documents related to the matter",
  },
  // {
  //   value: "parenting_plan",
  //   label: "Parenting Plan",
  //   description: "Document parenting plans and agreements",
  // },
  {
    value: "pleading",
    label: "Pleading",
    description: "Log pleadings filed in the matter",
  },
  {
    value: "notes",
    label: "Notes",
    description: "Add notes related to the matter",
  },
];

const ChooseDocumentType: React.FC<ChooseDocumentTypeProps> = ({
  type,
  setType,
}) => {
  return (
    <div className="grid justify-center w-full max-w-3xl grid-cols-1 gap-4 mt-8 sm:grid-cols-2 md:grid-cols-3">
      {options.map((value) => (
        <div
          key={value.value}
          className={`flex flex-col items-center w-full p-6 rounded-lg shadow-md cursor-pointer transition-colors ${
            type === value.value
              ? "bg-blue-100 dark:bg-blue-900"
              : "bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
          }`}
          onClick={() => {
            setType(value.value);
          }}
        >
          {/* <img
                src={assets[key as keyof typeof assets]}
                alt={key}
                className="w-24 h-24 mb-3"
                /> */}
          <Subheading>{value.label}</Subheading>
        </div>
      ))}
    </div>
  );
};

export default ChooseDocumentType;
